import type { Ad } from '@adrise/player';

import { VODPlaybackSession } from 'client/features/playback/session/VODPlaybackSession';
import { TRACK_LOGGING, LOG_SUB_TYPE } from 'common/constants/error-types';
import { convertUnitWithMathRound } from 'common/utils/convertUnitWithMathRound';
import { nullishCoalescingWrapper } from 'common/utils/nullishCoalescingWrapper';
import { trackLogging } from 'common/utils/track';

import { PLAYER_ANALYTICS_EVENT_VERSION } from './utils/types';
import { playerAnalyticsAdStartupPerformance } from '../analytics-ingestion-v3';

interface AdStartupPerformanceParams {
  ad?: Ad;
  adSequence?: number;
  adsCount?: number;
  adPosition?: number;
  isPreroll?: boolean;
  metrics: {
    [x: string]: number;
  };
  preloaded: boolean;
}

export function trackAdStartupPerformance(
  { metrics, preloaded, ...data }: AdStartupPerformanceParams,
): void {
  const {
    first_frame_time,
    frag_loaded_time,
    manifest_loaded_time,
  } = metrics;
  const playerAnalyticsData = {
    log_version: PLAYER_ANALYTICS_EVENT_VERSION,
    track_id: VODPlaybackSession.getVODPlaybackInfo().trackId,
    ad_id: nullishCoalescingWrapper(data.ad?.id, ''),
    url: nullishCoalescingWrapper(data.ad?.video, ''),
    is_preroll: data.isPreroll,
    ad_index: data.adSequence,
    ad_count: data.adsCount,
    duration: data.ad?.duration !== undefined ? data.ad.duration * 1000 : undefined, // millisecond
    first_frame_time, // millisecond
    frag_loaded_time, // millisecond
    manifest_loaded_time, // millisecond
    preloaded,
  };
  trackLogging({
    type: TRACK_LOGGING.videoInfo,
    subtype: LOG_SUB_TYPE.PLAYBACK.AD_STARTUP_PERFORMANCE,
    message: {
      ...playerAnalyticsData,
      metrics,
    },
  });
  playerAnalyticsAdStartupPerformance({
    ...playerAnalyticsData,
    duration: convertUnitWithMathRound(data.ad?.duration, 1000), // millisecond
    first_frame_time: Math.round(first_frame_time), // millisecond
    frag_loaded_time: Math.round(frag_loaded_time), // millisecond
    manifest_loaded_time: Math.round(manifest_loaded_time), // millisecond
  });
}
